export default {
  page: "Cart"
};
